const siteMetadata = {
  title: 'Tajammal Maqbool',
  author: 'Tajammal Maqbool',
  headerTitle: 'Tajammal Maqbool',
  description: 'Tajammal Maqbool is a Full Stack & Game Developer who loves crafting software and games that stay accessible and easy to use.',
  language: 'en-us',
  theme: 'system',
  siteUrl: 'https://tajammalmaqbool.com',
  siteLogo: '/logo.png',
  socialBanner: '/logo.png',
  email: 'contact@tajammalmaqbool.com',
  github: 'https://github.com/Tajammal-Maqbool/',
  youtube: 'https://www.youtube.com/channel/UCZR97jd_dzea23FqiwjP9pg/',
  linkedin: 'https://www.linkedin.com/in/tajammal-maqbool/',
  upwork: "https://www.upwork.com/freelancers/tajammalmaqbool/",
  medium: "https://www.medium.com/@tajammalmaqbool11/",
  itchio: "https://tajammalmaqbool.itch.io/",
  patreon: "https://patreon.com/TajammalMaqbool?utm_medium=unknown&utm_source=join_link&utm_campaign=creatorshare_creator&utm_content=copyLink",
  locale: 'en-US',
}

export default siteMetadata